import React from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import colors from "../../../../helpers/colors";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 75px;
`;

const TableSection = () => {
  return (
    <Wrapper>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        border="1"
        cellSpacing="0"
        cellPadding="8"
      >
        <thead>
          <tr>
            <th style={{ width: "40%" }}></th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
          </tr>
        </thead>
        <tbody>
          {/* Section: Recognition Programs */}
          <tr>
            <th
              colSpan="4"
              style={{ textAlign: "left", backgroundColor: "#f0f0f0" }}
            >
              Recognition Programs
            </th>
          </tr>
          <tr>
            <td>
              <strong>Nomination-based Awards and Badges</strong>
              <br />
              Customize Awards and Badges for nomination awards like Employee of
              the Month, CEO awards, and more.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Automated Milestone Awards/Service Awards</strong>
              <br />
              Celebrate employees on the days that are important to them
              (birthdays, anniversaries, and more).
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Challenges, Achievements, & Incentives</strong>
              <br />
              Build opportunities for challenges, achievements, and incentives
              within your recognition program.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Peer-to-Peer Recognition</strong>
              <br /> Allow employees to recognize their peers instead of waiting
              for management to notice good work.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>

          <tr>
            <td>
              <strong>Employee & Group QR Codes</strong>
              <br />
              Use QR codes for appreciation on the go or deskless team members.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Public (or Private) Recognition</strong>
              <br />
              Make employee recognition public for everyone to see or keep
              recognition private, based on employee preferences.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Integration of Company Values</strong>
              <br />
              Tie recognition rewards to your company values to reinforce
              positive behaviors.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Bulk Recognition</strong>
              <br />
              Recognize more than one employee at a time.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Spot Recognitions</strong>
              <br />
              Celebrate employees who go above and beyond with a one-time
              special recognition.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Service Shoutouts</strong>
              <br />
              Allow customers and patrons to recognize your employees for
              outstanding service.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
          <tr>
            <td>
              <strong>Value Flexibility/Currency Configuration</strong>
              <br />
              Choose to give points or dollars and configure your program
              currency value based on your company’s needs.
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
            <td style={{ textAlign: "center" }}>
              <input type="checkbox" style={{ transform: "scale(0.4)" }} />
            </td>
          </tr>
        </tbody>
      </table>

      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        border="1"
        cellSpacing="0"
        cellPadding="8"
      >
        <thead>
          <tr>
            <th style={{ width: "40%" }}></th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              colSpan="4"
              style={{ textAlign: "left", backgroundColor: "#f0f0f0" }}
            >
              Reward Redemption Options
            </th>
          </tr>

          {[
            {
              title: "Gift Cards",
              description:
                "Allow employees to choose from a huge library of gift cards specific to their country.",
            },
            {
              title: "Cash Outs",
              description:
                "Offer cash payouts as a reward from PayPal or Venmo.",
            },
            {
              title: "Charitable Donations",
              description:
                "Choose from pre-approved charities or create an internal cause so employees can donate their reward dollars.",
            },
            {
              title: "Automated Employee Gifting Options",
              description:
                "Gift a shopping spree, a select number of items from a catalog, or specifically curated items.",
            },
            {
              title: "Redemption-Only Gifting",
              description:
                "Offer solutions for employees who only receive gifts/rewards and won’t be included in the recognition platform (part-time employees, contractors, etc).",
            },
            {
              title: "External Gifting",
              description:
                "Send gifts outside your organization (non-FTEs/employees such as vendors, customers, etc).",
            },
            {
              title: "Amazon Shopping",
              description:
                "Allow employees to select rewards from Amazon, and pay no markup fees.",
            },
            {
              title: "Inventory Management & Storefront Controls",
              description:
                "Maintain full control over store inventory, connected stores, and the redemption experience.",
            },
            {
              title: "Connected Shopping Sites",
              description:
                "Add any Shopify-supported store to your employee rewards marketplace and filter by local vendors.",
            },
            {
              title: "Seamless Checkout Experience",
              description:
                "Offer a quick and easy checkout experience for employees.",
            },
            {
              title: "International & Local Fulfillment",
              description:
                "Allow all of your employees around the world to shop and have rewards shipped at a low cost.",
            },
            {
              title: "Custom Rewards Catalogs",
              description: "Curate rewards for specific programs or groups.",
            },
            {
              title: "Lifestyle Spending Accounts",
              description:
                "Offer a lifestyle spending account for wellness initiatives (physical, mental, or financial).",
            },
            {
              title: "Rewards Dollars Tied to a Debit Card",
              description:
                "Get instant access to reward dollars and spend it where Visa is accepted.",
            },
            {
              title: "Integrated Swag",
              description:
                "Leverage a swag partner, connect it to your rewards platform, or get done-for-you swag.",
            },
            {
              title: "Flexible Redemption",
              description:
                "Enable employees to decide how they want to spend rewards balances; gift cards, swag, etc.",
            },
            {
              title: "Custom Rewards",
              description:
                "Personalize rewards and offer custom options, like an extra day of PTO.",
            },
            {
              title: "Travel & Experiences/Perks",
              description:
                "Offer travel and experience packages and consumer discounts.",
            },
          ].map(({ title, description }) => (
            <tr key={title}>
              <td>
                <strong>{title}</strong>
                <br />
                {description}
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        border="1"
        cellSpacing="0"
        cellPadding="8"
      >
        <thead>
          <tr>
            <th style={{ width: "40%" }}></th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              colSpan="4"
              style={{ textAlign: "left", backgroundColor: "#f0f0f0" }}
            >
              Social Recognition Platform
            </th>
          </tr>

          {[
            {
              title: "Social Feed",
              description:
                "See a social feed filled with news and recognitions (with a filter to show recency and relevancy).",
            },
            {
              title: "Employee Profiles",
              description:
                "See information about each employee including key interests and bios, birthdays, hire dates, and more.",
            },
            {
              title: "Organization Chart",
              description: "View a complete org chart for your business.",
            },
            {
              title: "Personality Test/Profiles",
              description:
                "Take a personality assessment, view your personality profile, and get guidance about interacting with your colleagues.",
            },
            {
              title: "Global Search",
              description:
                "Find what you need to know with a comprehensive search of your recognition platform.",
            },
            {
              title: "Easy Setup and Controls",
              description:
                "Get started quickly with a user-friendly interface and setup process.",
            },
            {
              title: "HRIS Integrations",
              description:
                "Integrate with your HRIS for a seamless recognition experience.",
            },
            {
              title: "SSO",
              description: "Implement SSO for increased security.",
            },
            {
              title: "Collaboration Tool Integrations",
              description: "Integrate with your existing collaboration tools.",
            },
            {
              title: "Custom People Organization",
              description:
                "Build out a custom people organization with user groups and custom rules.",
            },
            {
              title: "Budget and Funding Management",
              description:
                "Create, run, and fund multiple budgets for your people programs and see comprehensive burnup reporting.",
            },
            {
              title: "Reports, Dashboards, and Analytics",
              description:
                "Get insights into recognition received per person, by day, given per person, and more.",
            },
            {
              title: "AI",
              description:
                "Leverage AI for reporting insights, industry benchmark comparisons, and recommendations for improvement.",
            },
          ].map(({ title, description }) => (
            <tr key={title}>
              <td>
                <strong>{title}</strong>
                <br />
                {description}
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <p>
        Employee recognition doesn’t just affect your recognition & rewards
        program. In fact, elements of employee recognition, rewards, and
        experience bleed over into nearly every HR initiative and people program
        you’re likely running. To maximize the benefits of your people programs
        and increase engagement, finding a recognition tool that also
        incorporates internal communication tools is a game changer.{" "}
      </p>

      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        border="1"
        cellSpacing="0"
        cellPadding="8"
      >
        <thead>
          <tr>
            <th style={{ width: "40%" }}></th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              colSpan="4"
              style={{ textAlign: "left", backgroundColor: "#f0f0f0" }}
            >
              Internal Communications
            </th>
          </tr>

          {[
            {
              title: "Employee and Company Spaces",
              description:
                "Create spaces for specific groups of employees (e.g. key programs, initiatives, etc.).",
            },
            {
              title: "Resources & Assets",
              description:
                "Create, manage, and store all of your relevant resources by libraries in the context of their programs.",
            },
            {
              title: "Resource Insights",
              description:
                "Pin or highlight specific resources for the company, specific teams, special groups, etc.",
            },
            {
              title: "Event Management",
              description:
                "Host events in context of their programs and make sure employees are always up to date on critical information.",
            },
            {
              title: "Announcements",
              description:
                "Keep everyone on the same page for upcoming events, messages, and company information.",
            },
            {
              title: "Highlights",
              description:
                "Celebrate a team, event, or a certain individual (new hires, team lunch, etc.).",
            },
            {
              title: "Post Scheduling",
              description: "Schedule a future message or announcement.",
            },
            {
              title: "Targeted/Segmented Communication",
              description:
                "Select who receives specific announcements/messages.",
            },
            {
              title: "Post Engagement Insights",
              description:
                "See engagement insights on posts from HR or the c-suite.",
            },
            {
              title: "Program-Specific Awards and Challenges",
              description:
                "Create and manage awards, challenges, and incentives for your people programs.",
            },
          ].map(({ title, description }) => (
            <tr key={title}>
              <td>
                <strong>{title}</strong>
                <br />
                {description}
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p>
        Beyond employee recognition features and tools to simplify your internal
        communication efforts, the right recognition tool will also include
        features that enhance the employee experience. Recognition and
        streamlined internal communication are critical to building and
        improving great culture, but to truly understand the impact that your
        programs are making—look for a tool that will also help improve your
        employee listening skills.{" "}
      </p>

      {/* <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        border="1"
        cellSpacing="0"
        cellPadding="8"
      >
        <thead>
          <tr>
            <th style={{ width: "40%" }}></th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
            <th>
              Software name:
              <br />
              __________
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th
              colSpan="4"
              style={{ textAlign: "left", backgroundColor: "#f0f0f0" }}
            >
              Employee Surveys & Feedback
            </th>
          </tr>

          {[
            {
              title: "Employee Surveys",
              description:
                "Send surveys bi-annually, quarterly, and even monthly to keep tabs on employee satisfaction and feedback.",
            },
            {
              title: "Actionable Insights",
              description:
                "Learn from employee feedback and take actionable steps to improve your culture.",
            },
            {
              title: "eNPS Data",
              description:
                "Gather eNPS results (anonymously) regularly to find out how employees feel about their job and the company.",
            },
            {
              title: "Pulse Surveys",
              description:
                "Understand team satisfaction throughout the organization with a quick pulse survey.",
            },
            {
              title: "Reporting",
              description:
                "Identify trends, compare against industry benchmarks, and make better-informed decisions to improve employee engagement.",
            },
            {
              title: "Custom Surveys",
              description:
                "Increase employee participation in surveys by tailoring the survey to your needs and your employees (surveys can be customized by team, department, or the entire company).",
            },
          ].map(({ title, description }) => (
            <tr key={title}>
              <td>
                <strong>{title}</strong>
                <br />
                {description}
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
              <td style={{ textAlign: "center" }}>
                <input type="checkbox" style={{ transform: "scale(0.4)" }} />
              </td>
            </tr>
          ))}
        </tbody>
      </table> */}
    </Wrapper>
  );
};

export default TableSection;
